module.exports = __webpack_public_path__ + "img/raw.b0e0005.svg";